import Api from '@/services/Api'

export default {
  async put(step) {
    Api().put(process.env.VUE_APP_QUERY_URL_STEPS + '/' + step.id, step)
      .then(function (response) {
        console.log('>>> step updated');
        console.log(response);
      })
      .catch(function (error) {
        console.log(error);
      })
  },
  async get(id) {
    return await Api().put(process.env.VUE_APP_QUERY_URL_STEPS + '/' + id)
      .then(function (response) {
        console.log('>>> get step updated ' + id);
        return response.data;
      })
      .catch(function (error) {
        console.log(error);
      })
  },
  async create(step) {
    return await Api().post(process.env.VUE_APP_QUERY_URL_STEPS, step)
      .then(function (response) {
        console.log('>>> step created');
        return response.data;
      })
      .catch(function (error) {
        console.log(error);
      })
  },
  async delete(step) {
    Api().delete(process.env.VUE_APP_QUERY_URL_STEPS + '/' + step.id)
      .then(function (response) {
        console.log('>>> step delete');
        console.log(response);
      })
      .catch(function (error) {
        console.log(error);
      })
  }
}